<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_5">CONTENTS:</a></p><a id="page_5">
</a><p class="toct"><a id="page_5"></a><a href="#/xhtml/07_Introduction"><b>INTRODUCTION</b></a></p>
<p class="toct"><a href="#/xhtml/08_Part01"><b>PART ONE: The Invention of Old Town</b></a></p>
<p class="toc"><a href="#/xhtml/09_Chapter01">Chapter One: Tower Town and the Gold Coast</a></p>
<p class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">Chapter Two: Rehabbing and Redlining</span></p>
<p class="toct"><span href="#/xhtml/11_Part02" title="Link target outside of Sample"><b>PART TWO: The Conservation of Lincoln Park</b></span></p>
<p class="toc"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">Chapter Three: Strict Enforcement</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">Chapter Four: The Special Situation</span></p>
<p class="toct"><span href="#/xhtml/14_Part03" title="Link target outside of Sample"><b>PART THREE: The Battle of Lincoln Park</b></span></p>
<p class="toc"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample">Chapter Five: Project One</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample">Chapter Six: Concerned Citizens</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter07" title="Link target outside of Sample">Chapter Seven: The Poor People’s Coalition</span></p>
<p class="toct"><span href="#/xhtml/18_Conclusion" title="Link target outside of Sample"><b>CONCLUSION</b></span></p>
<p class="toca"><span href="#/xhtml/19_Acknowledgement" title="Link target outside of Sample"><b>ACKNOWLEDGEMENTS</b></span></p>
<p class="toca"><span href="#/xhtml/20_Bm01" title="Link target outside of Sample"><b>SOURCES</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?17b38667